import classnames from 'classnames';
import Image from 'components/Image';
import { ITooltipData } from 'components/ModalTooltip/types';
import React from 'react';
import { connect } from 'react-redux';
import { IAppState } from 'types/app';
import { ICard } from 'types/cards';

import getBorderColour from 'utils/getBorderColour';

type OwnProps = {
  cardData: ICard,
  tooltipData: ITooltipData,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps>;

function SmallCard({ cardData, isFetching, tooltipData }: Props) {

  const borderColour = getBorderColour(cardData);

  return (
    <div
      className={classnames(
        'card storylet__card',
        isFetching && 'card--fetching',
      )}
    >
      <Image
        borderContainerClassName="small-card__border"
        className="small-card__image"
        icon={cardData.image}
        alt={cardData.name}
        border={borderColour}
        tooltipData={tooltipData}
      />
    </div>
  );
}

SmallCard.displayName = 'SmallCard';

const mapStateToProps = ({ cards: { isFetching } }: IAppState) => ({ isFetching });

export default connect(mapStateToProps)(SmallCard);